import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import { BillingPaymentMethod } from "@/Common/Models/UI/BillingPaymentMethod";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { BaseSendToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendToPortalPopupStrategy";
import { ISendToPortalAndPrintPopupStrategy } from "@/Portal/Services/Strategies/ISendToPortalPopupStrategy";

class SendInvoiceStrategy extends BaseSendToPortalPopupStrategy implements ISendToPortalAndPrintPopupStrategy {
    public readonly disclaimer: string = "";
    public readonly itemCheckOperation: number = LocalPatientOperations.History.OnPortalInvoiceMessageChecked;

    public get sendAndPrintLabel(): string {
        return cacheStore.GetString("SyncAndPrintLabel");
    }

    constructor(
        privateBillIsClosed: boolean,
        paymentMethod: BillingPaymentMethod
    ) {
        super(
            PortalLinkedItemType.PrivateBill,
            LocalPatientOperations.History.PrivateBill_PortalStatusRevoke,
            LocalPatientOperations.History.PrivateBill_PortalStatusCancel,
            !privateBillIsClosed && cacheStore.GetString("SyncAndCloseLabel")
        );

        this.disclaimer = !privateBillIsClosed
            ? this.getDisclaimerMessage(paymentMethod)
            : "";
    }

    public onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, _portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): void {
        sessionStore.dispatch(
            LocalPatientOperations.History.PrivateBill_SendBillToPortal,
            {
                subject: subject,
                messageText: newMessage,
                includeDocument: includeDocument,
                priority: priority,
                canPatientReplyWithMessage: canPatientReplyWithMessage
            }
        );
    }

    public onSendAndPrintClick(subject: string, newMessage: string, includeDocument: boolean): void {
        sessionStore.dispatch(
            LocalPatientOperations.History.PrivateBill_SendBillToPortalThenPrint,
            {
                subject: subject,
                messageText: newMessage,
                includeDocument: includeDocument
            }
        );
    }

    private getDisclaimerMessage(paymentMethod: BillingPaymentMethod): string {
        return paymentMethod === BillingPaymentMethod.Payable ?
            cacheStore.GetString("DisclaimerPortalPayableBillWarningLabel") :
            cacheStore.GetString("DisclaimerPortalWarningLabel");
    }
}

export { SendInvoiceStrategy };
